import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./AdminLogin.css"; // Reuse same styling
import { jwtDecode } from "jwt-decode";

const UsherLogin = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/users/login`, { email, password });
            const { token } = res.data;
            const decoded = jwtDecode(token);

            if (decoded.role !== "usher") {
                setError("You are not authorized to login as usher.");
                return;
            }

            localStorage.setItem("token", token);
            localStorage.setItem("isUsher", "true");
            navigate("/admin/scan-ticket");
        } catch (err) {
            setError("Invalid credentials.");
        }
    };

    return (
        <div className="AdminLoginPageCSS">
            <div className="admin-login-container">
                <h2>Usher Login</h2>
                {error && <p className="error">{error}</p>}
                <form onSubmit={handleLogin}>
                    <label>Email:</label>
                    <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                    <label>Password:</label>
                    <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                    <button type="submit">Login</button>
                </form>
            </div>
        </div>
    );
};

export default UsherLogin;
